export default {
  title: 'Informacje o firmie',
  form: {},
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    success: 'Twoje informacje zostały pomyślnie zapisane.',
  },
};
